import React, { useState } from 'react';

interface SidebarProps {
  classes?: string;
  children?: React.ReactNode;
  open?: boolean;
}

const Sidebar = (props: SidebarProps) => {
  const [toggle, setToggle] = useState(props.open);

  const toggleSidebar = () => {
    setToggle(!toggle);
  };

  return (
    <div className={'sidebar ' + props.classes ?? ''}>
      <input
        type='checkbox'
        className='openSidebarMenu'
        id='openSidebarMenu'
        defaultChecked={toggle}
      />

      <div id='sidebarMenu'>
        <label
          htmlFor='openSidebarMenu'
          className='sidebarIconToggle'
          onClick={toggleSidebar}
        >
          {toggle ? (
            <i className='fas fa-chevron-right' />
          ) : (
            <i className='fas fa-chevron-left' />
          )}
        </label>
        <div className={'sidebar-content'}>{props.children}</div>
      </div>
    </div>
  );
};

export default Sidebar;
